import type { ReactNode } from 'react';

export function FooterSections({ children }: { children: ReactNode }) {
  return <div className="flex w-full flex-col sm:flex-row sm:justify-between sm:gap-10">{children}</div>;
}
